import flowsStore from './flows.store';
import flowFoldersStore from './flowFolders.store';
import flowUserFavoritesStore from './flowUserFavorites.store';

export default {
  flows: flowsStore,
  flowFolders: flowFoldersStore,
  flowUserFavorites: flowUserFavoritesStore,
};
